

import "bootstrap/dist/js/bootstrap";

import * as bootstrap from "bootstrap";

window.bootstrap = bootstrap;
